"use client";

import { CheckCircle2, AlertCircle } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { ViewHeader, ViewIcon } from "./ViewHeader";
import { loginPrimaryButtonClasses } from "./styles";

/** Resultado del flujo de recuperación. El título dice qué pasó; el ícono solo lo refuerza. */
export function StatusView({
  type,
  title,
  text,
  btnText,
  onAction,
}: {
  type: "success" | "error";
  title: string;
  text: string;
  btnText: string;
  onAction: () => void;
}) {
  const isSuccess = type === "success";
  const Icon = isSuccess ? CheckCircle2 : AlertCircle;

  return (
    <div className="flex w-full flex-col">
      <ViewHeader
        icon={
          <ViewIcon tone={isSuccess ? "success" : "error"}>
            <Icon className="h-[22px] w-[22px]" />
          </ViewIcon>
        }
        title={title}
        subtitle={text}
      />

      <Button type="button" onClick={onAction} autoFocus className={loginPrimaryButtonClasses}>
        {btnText}
      </Button>
    </div>
  );
}
